import {DateTime} from "luxon";
import {TicketInterface} from "@api/models/interfaces/tickets/TicketInterface";
import {TableItem} from "@api/models/interfaces/TableItem";
import {setDates} from "@api/models/helpers/DatesSetter";

export class Ticket implements TicketInterface, TableItem {
    id: string;
    isPublished: boolean | null;
    createdAt: string | DateTime | null;
    updatedAt: string | DateTime | null;
    updatedBy: number | null;
    ownerId?: number | null;
    ownerIds: number[] | null;
    title: string | null;
    description: string | null;
    category: string | null;
    status: string | null;
    company: string | null;
    branch: string | null;
    direction: string | null;
    responsibleUserId: number | null;
    fileIds: string[] | null;
    imageFileIds: string[] | null;
    responsibleForImplementationUserId: number | null;

    [key: string]: any;

    constructor(data: TicketInterface | {}) {
        Object.assign(this, data);
        setDates(this, ['createdAt', 'publishedAt', 'updatedAt']);
    }

    getField(fieldName: string): string | any {
        return this[fieldName] || '';
    }
}
